import { IPaginator } from '../store/root.types'
import axiosInstance from './axios'
import { AxiosResponse } from 'axios'
import { IActionInstitutionsDescribe, IActionInstitutionsRequest } from '../store/institutions/types'

class IntitutionsService {
    constructor(private apiVersion: string = 'v1') {
    }

    public async institution(filters: IActionInstitutionsRequest): Promise<any> {
        try {
            const params: URLSearchParams = new URLSearchParams()
            if (filters.cnpj) params.append('cnpj', String(filters.cnpj))
            if (filters.uf) params.append('uf', String(filters.uf))
            if (filters.municipality) params.append('municipality', String(filters.municipality))
            if (filters.name) params.append('name', String(filters.name))

            return axiosInstance.get(`${this.apiVersion}/institutions`, { params })
                .then((response: AxiosResponse) => response.data)
        } catch (err: any) {
            throw new Error(err.message)
        }
    }

    public async getEmps(filters: IActionInstitutionsDescribe, paginator: IPaginator): Promise<any> {
        try {
            const params: URLSearchParams = this.buildParams(paginator, filters)
            const url: string = `${this.apiVersion}/institutions/${filters.cnpj}/commitments`
            return axiosInstance.get(url, { params })
                .then((response: AxiosResponse) => {
                    return {
                        data: response.data,
                        total: response.headers['x-total-count']
                    }
                })
        } catch (err: any) {
            throw new Error(err.message)
        }
    }

    public async getBiddings(filters: IActionInstitutionsDescribe, paginator: IPaginator): Promise<any> {
        try {
            const params: URLSearchParams = this.buildParams(paginator, filters)
            const url: string = `${this.apiVersion}/institutions/${filters.cnpj}/biddings`
            return axiosInstance.get(url, { params })
                .then((response: AxiosResponse) => {
                    return {
                        data: response.data,
                    }
                })
        } catch (err: any) {
            throw new Error(err.message)
        }
    }

    public async getContracts(filters: IActionInstitutionsDescribe, paginator: IPaginator): Promise<any> {
        try {
            const params: URLSearchParams = this.buildParams(paginator, filters)
            const url: string = `${this.apiVersion}/institutions/${filters.cnpj}/contracts`
            return axiosInstance.get(url, { params })
                .then((response: AxiosResponse) => {
                    return {
                        data: response.data,
                    }
                })
        } catch (err: any) {
            throw new Error(err.message)
        }
    }

    public async getAdditives(filters: IActionInstitutionsDescribe, paginator: IPaginator): Promise<any> {
        try {
            const params: URLSearchParams = this.buildParams(paginator, filters)
            const url: string = `${this.apiVersion}/institutions/${filters.cnpj}/additives`
            return axiosInstance.get(url, { params })
                .then((response: AxiosResponse) => {
                    return {
                        data: response.data,
                    }
                })
        } catch (err: any) {
            throw new Error(err.message)
        }
    }

    public async getPayments(filters: IActionInstitutionsDescribe, paginator: IPaginator): Promise<any> {
        try {
            const params: URLSearchParams = this.buildParams(paginator, filters)
            const url: string = `${this.apiVersion}/institutions/${filters.cnpj}/payments`
            return axiosInstance.get(url, { params })
                .then((response: AxiosResponse) => {
                    return {
                        data: response.data,
                    }
                })
        } catch (err: any) {
            throw new Error(err.message)
        }
    }

    public async getPayrollRecords(filters: IActionInstitutionsDescribe, paginator: IPaginator): Promise<any> {
        try {
            const params: URLSearchParams = this.buildParams(paginator, filters)
            const url: string = `${this.apiVersion}/institutions/${filters.cnpj}/payrollrecords`
            return axiosInstance.get(url, { params })
                .then((response: AxiosResponse) => {
                    return {
                        data: response.data,
                    }
                })
        } catch (err: any) {
            throw new Error(err.message)
        }
    }

    public async getNotes(filters: IActionInstitutionsDescribe, paginator?: IPaginator): Promise<any> {
        try {
            const params: URLSearchParams = this.buildParams(paginator, filters)
            return axiosInstance.get(
                `${this.apiVersion}/institutions/${filters.cnpj}/nfes`,
                { params })
                .then((response: AxiosResponse) => response.data)
        } catch (err: any) {
            throw new Error(err.message)
        }
    }

    public async getProducts(acess_key: string, cnpj: string): Promise<any> {
        try {
            return axiosInstance.get(
                `${this.apiVersion}/institutions/${cnpj}/nfes/${acess_key}/products`)
                .then((response: AxiosResponse) => response.data)
        } catch (err: any) {
            throw new Error(err.message)
        }
    }

    /**
     * Method to convert {@link IPaginator} object to {@link URLSearchParams}.
     * @param {IPaginator} [paginator] Paginator settings.
     * @param {IActionDocumentsRequest} [filters] Paginator settings
     * @return {URLSearchParams} Resulting object.
     */
    public buildParams(paginator?: IPaginator, filters?: IActionInstitutionsDescribe): URLSearchParams {
        const params = new URLSearchParams()
        if (paginator) {

            if (paginator.page) {
                params.append('page', String(paginator.page + 1))
            }

            if (paginator.rows) {
                params.append('limit', String(paginator.rows))
            }
        }

        if (filters) {

            if (filters?.access_key) {
                params.append('access_key', String(filters.access_key))
            }
            if (filters?.start_date) {
                params.append('start_date', String(filters.start_date))
            }
            if (filters?.end_date) {
                params.append('end_date', String(filters.end_date))
            }
            if (filters?.issuer_document) {
                params.append('issuer_document', String(filters.issuer_document))
            }
            if (filters?.issuer_corporate_name) {
                params.append('issuer_corporate_name', String(filters.issuer_corporate_name))
            }
            if (filters?.recipient_document) {
                params.append('recipient_document', String(filters.recipient_document))
            }
            if (filters?.recipient_corporate_name) {
                params.append('recipient_corporate_name', String(filters.recipient_corporate_name))
            }
            if (filters?.month) {
                params.append('month', String(filters.month))
            }
            if (filters?.year) {
                params.append('year', String(filters.year))
            }
            if (filters?.issuer_ip) {
                params.append('ip', String(filters.issuer_ip))
            }
            if (filters?.port) {
                params.append('port', String(filters.port))
            }
        }
        return params
    }
}

const institutionsService = new IntitutionsService()

export default institutionsService
